/* Canvas Partner Portal — soft two-code gate + audience routing + library render.
   Soft gating only: codes live in the page; keeps out casual visitors, not determined ones. */
(function () {
  var root = document.querySelector('.cpp');
  if (!root) return;
  var DATA = {};
  try {
    var _raw = (document.getElementById('cpp-data').textContent || '')
      .replace('/*CPP_DATA_START*/', '').replace('/*CPP_DATA_END*/', '').trim();
    DATA = JSON.parse(_raw);
  } catch (e) { console.error('[partner-portal] data parse failed', e); return; }
  var CFG = {
    code1: (root.dataset.code1 || '').trim().toUpperCase(),
    code2: (root.dataset.code2 || '').trim().toUpperCase(),
    contact: root.dataset.contact || '/pages/contact',
    biglib: root.dataset.biglib || '',
    designer: root.dataset.designer || '/pages/custom-paddle-designer',
    email: root.dataset.email || 'grahm@canvaspickleball.com'
  };
  var state = { tier: 0, audience: null, q: '', tab: null, sub: null, view: null };

  /* ---------- ROUTING ----------
     #corporate / #weddings / ... land a visitor straight on their audience page after
     the gate, so a link can pre-sort the person it is sent to. #library opens the full
     library. The hash also survives the gate reload, which is the point. */
  function readRoute() {
    var h = (location.hash || '').replace('#', '').trim().toLowerCase();
    if (!h) return null;
    if (h === 'library' || h === 'all') return { view: 'all' };
    if (audienceById(h)) return { audience: h };
    return null;
  }
  function writeRoute() {
    var h = state.audience ? '#' + state.audience : (state.view === 'all' ? '#library' : '');
    if (history.replaceState) history.replaceState(null, '', location.pathname + location.search + h);
  }
  function selectAudience(aid) {
    var au = audienceById(aid);
    state.audience = aid; state.view = null; state.q = '';
    state.tab = (au && au.imgTab) || null; state.sub = (au && au.imgSub) || null;
    var si = $('.cpp-search input'); if (si) si.value = '';
    writeRoute();
  }

  var $ = function (s, c) { return (c || root).querySelector(s); };
  var el = function (tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; };
  var esc = function (s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  var ICONS = {
    store: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 9l1-5h16l1 5M4 9v10h16V9M4 9h16"/></svg>',
    gift: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="8" width="18" height="13" rx="1"/><path d="M12 8v13M3 12h18M12 8S9 2 6.5 4 12 8 12 8zM12 8s3-6 5.5-4S12 8 12 8z"/></svg>',
    heart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 21s-7-4.5-9.5-9A5 5 0 0112 5a5 5 0 019.5 7c-2.5 4.5-9.5 9-9.5 9z"/></svg>',
    trophy: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M8 21h8M12 17v4M7 4h10v5a5 5 0 01-10 0V4zM7 5H4v2a3 3 0 003 3M17 5h3v2a3 3 0 01-3 3"/></svg>',
    home: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 11l9-8 9 8M5 10v10h14V10"/></svg>',
    building: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="4" y="3" width="16" height="18" rx="1"/><path d="M8 7h2M14 7h2M8 11h2M14 11h2M8 15h2M14 15h2"/></svg>',
    calendar: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M8 3v4M16 3v4M3 10h18"/></svg>',
    landmark: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 21h18M4 18h16M6 18v-7M10 18v-7M14 18v-7M18 18v-7M3 11l9-7 9 7z"/></svg>',
    lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 018 0v4"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M20 6L9 17l-5-5"/></svg>',
    search: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4-4"/></svg>'
  };

  /* ---------- GATE ----------
     Tier 1 is a shared code checked in the page: it keeps out casual visitors only.
     Tier 2 changed on 4 Sep 2026: the wholesale layer (sheets, URLs, the partner
     ladder) travels as an ENCRYPTED bundle in the blob and no wholesale code exists
     anywhere in page source. Entering the right code is the decryption key; a wrong
     code simply fails to decrypt. See _encrypt_bundle in .tools/build_portal_data.py
     for the matching scheme. */
  function tryCode(v) {
    v = (v || '').trim().toUpperCase();
    if (CFG.code1 && v === CFG.code1) return 1;
    return 0;
  }
  function saveTier(t) { state.tier = t; } /* no persistence — code required every visit */

  function b64u8(s) {
    var bin = atob(s), u = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) u[i] = bin.charCodeAt(i);
    return u;
  }
  var whMerged = false;
  function mergeWholesale(bundle) {
    if (whMerged) return;
    whMerged = true;
    (bundle.items || []).forEach(function (it) { DATA.items.push(it); });
    var pages = bundle.pages || {};
    Object.keys(pages).forEach(function (aid) {
      var target = (DATA.pages || {})[aid];
      if (!target) return;
      Object.keys(pages[aid]).forEach(function (blockKey) {
        target[blockKey] = Object.assign({}, target[blockKey] || {}, pages[aid][blockKey]);
      });
    });
  }
  /* resolves true and merges the wholesale layer if the code decrypts the bundle */
  function unlockWholesale(code) {
    code = (code || '').trim().toUpperCase();
    if (whMerged) return Promise.resolve(true);
    if (!code || !DATA.wh || !window.crypto || !crypto.subtle) return Promise.resolve(false);
    var wh = DATA.wh, salt = b64u8(wh.salt), ct = b64u8(wh.ct), mac = b64u8(wh.mac);
    return crypto.subtle.importKey('raw', new TextEncoder().encode(code), 'PBKDF2', false, ['deriveBits'])
      .then(function (k) {
        return crypto.subtle.deriveBits({ name: 'PBKDF2', hash: 'SHA-256', salt: salt, iterations: wh.iter }, k, 512);
      })
      .then(function (bits) {
        var dk = new Uint8Array(bits), encKey = dk.slice(0, 32), macKey = dk.slice(32);
        return crypto.subtle.importKey('raw', macKey, { name: 'HMAC', hash: 'SHA-256' }, false, ['sign'])
          .then(function (mk) { return crypto.subtle.sign('HMAC', mk, ct); })
          .then(function (sig) {
            var s = new Uint8Array(sig);
            if (s.length !== mac.length) return false;
            var diff = 0;
            for (var i = 0; i < s.length; i++) diff |= s[i] ^ mac[i];
            if (diff) return false;
            var out = new Uint8Array(ct.length), made = 0, ctr = 0;
            function block() {
              var inp = new Uint8Array(36);
              inp.set(encKey);
              inp[32] = (ctr >>> 24) & 255; inp[33] = (ctr >>> 16) & 255;
              inp[34] = (ctr >>> 8) & 255; inp[35] = ctr & 255;
              return crypto.subtle.digest('SHA-256', inp).then(function (d) {
                var ks = new Uint8Array(d);
                for (var j = 0; j < 32 && made < ct.length; j++, made++) out[made] = ct[made] ^ ks[j];
                ctr++;
                return made < ct.length ? block() : out;
              });
            }
            return block().then(function (pt) {
              try { mergeWholesale(JSON.parse(new TextDecoder().decode(pt))); return true; }
              catch (e) { return false; }
            });
          });
      })
      .catch(function () { return false; });
  }

  function initGate() {
    var gate = $('.cpp-gate'), form = $('.cpp-gate__form'), input = $('.cpp-gate__input'), err = $('.cpp-gate__err');
    // 7 Oct 2026: a signed-in Shopify customer tagged club-member or reseller walks straight in (chunk 5 of the club plan).
    if ((root.dataset.member || '').trim()) { saveTier(1); gate.hidden = true; showPortal(); return; }
    gate.hidden = false;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (tryCode(input.value) === 1) { saveTier(1); gate.hidden = true; showPortal(); return; }
      err.textContent = 'Checking…';
      unlockWholesale(input.value).then(function (ok) {
        if (ok) { saveTier(2); err.textContent = ''; gate.hidden = true; showPortal(); }
        else { err.textContent = 'That code didn’t match. Check with your Canvas contact.'; input.select(); }
      });
    });
  }
  function showPortal() {
    $('.cpp-gate').hidden = true;
    $('.cpp-app').hidden = false;
    setTierBadge();
    var r = readRoute();
    if (r && r.audience) selectAudience(r.audience);
    else if (r && r.view) { state.view = 'all'; }
    render();
  }
  function setTierBadge() {
    var b = $('.cpp-tier');
    b.textContent = state.tier >= 2 ? 'Wholesale access' : 'Partner access';
    b.classList.toggle('cpp-tier--wh', state.tier >= 2);
  }

  /* ---------- HELPERS ---------- */
  function audienceById(id) { return DATA.audiences.filter(function (x) { return x.id === id; })[0]; }
  function catItems(catId, keys) {
    return DATA.items.filter(function (it) {
      if (it.cat !== catId) return false;
      if (keys && keys.indexOf(it.key) < 0) return false;
      return true;
    });
  }
  /* Two motions, not six verticals. Distributors and clubs RESELL: they mark our price up,
     so "your sell sheet" and "pricing to show your customers" are literally their job.
     Corporate, weddings, real estate and events BUY: they are the customer, so reseller
     wording read as though they had wandered into someone else's portal. */
  var MOTION = {
    distributors: 'resell', clubs: 'resell',
    corporate: 'buy', weddings: 'buy', realestate: 'buy', events: 'buy'
  };
  var DASH_LABEL = {
    resell: {
      guide: 'Start here', sales: 'Your sell sheet', pricing_customer: 'Pricing to show your customers',
      pricing_wholesale: 'Your wholesale pricing', displays: 'Print-ready displays'
    },
    buy: {
      guide: 'Start here', sales: 'The one-pager to forward', pricing_customer: 'What it costs',
      pricing_wholesale: 'Your wholesale pricing', displays: 'Print-ready displays'
    }
  };
  function labelFor(audId, secId, fallback) {
    var set = DASH_LABEL[MOTION[audId] || 'buy'] || {};
    return set[secId] || fallback;
  }

  /* What to actually DO, in order. Every package used to open by listing its own contents,
     which tells a first-time visitor nothing about where to start. Each path ends at the
     same place the "Ready to price it up?" block does, so the page has one destination. */
  var AUD_STEPS = {
    distributors: ['Line card first: your range, your margins and your resale floor.',
                   'Mock up a client logo in the paddle designer before you get on the call.',
                   'Enter your partner code to open dealer and bag pricing.'],
    corporate:    ['Send the product guide to whoever needs to see the range.',
                   'Fill in page 2 of the spec sheet: quantity, budget, the date you need them.',
                   'Send it back and we return pricing, a timeline and a free proof.'],
    weddings:     ['Start with the product guide for what can be branded.',
                   'Use page 2 of the spec sheet to set quantity, colours and your date.',
                   'Send it back and we return pricing and a timeline that works to the day.'],
    events:       ['Product guide first, then the event sheet for what works on site.',
                   'Print the displays for your venue. They are ready for any printer.',
                   'Tell us the date and the numbers and we will price it.'],
    realestate:   ['Skim the sell sheet for what agents hand over at closing.',
                   'Set volumes and branding on page 2 of the spec sheet.',
                   'Send it back for pricing and a timeline.'],
    clubs:        ['Product guide and sell sheet for what to stock.',
                   'Put the print-ready displays up in your space.',
                   'Ask about partner pricing to set your pro shop margin.']
  };
  function pathStrip(audId) {
    var steps = AUD_STEPS[audId];
    if (!steps) return null;
    var w = el('section', 'cpp-path');
    w.appendChild(el('h2', 'cpp-path__t', 'How to use this'));
    var ol = el('ol', 'cpp-path__l');
    steps.forEach(function (s) { ol.appendChild(el('li', null, esc(s))); });
    w.appendChild(ol); return w;
  }
  var AUD_INTRO = {
    distributors: 'The product guide and line card to resell Canvas. Your dealer pricing and bag pricing unlock with your wholesale code.',
    corporate: 'The one-pager, pricing and bundles to pitch branded gifts for clients and staff.',
    weddings: 'The planner one-pager, pricing and keepsake bundles for couples.',
    events: 'The event sheet, pricing and print-ready venue displays for tournaments and activations.',
    realestate: 'The closing-gift and amenity sell sheet, plus pricing.',
    clubs: 'The product guide, pricing and print-ready displays for your club or venue.'
  };

  /* ---------- WHAT THEY OPENED ----------
     Two transports on purpose, because neither one alone covers a portal visitor.

     1. Klaviyo. The onsite script IS on the page, injected by the Shopify app rather than
        by any theme file, so grepping the theme for it finds nothing and is misleading.
        window.klaviyo is a real client with identify(). It attaches an event only to a
        profile it already knows, which is why "Viewed Key Page" reads as never having
        fired: the visitor was anonymous, not the transport missing.

     2. A local record, which is what canvas-capture already does for key pages and the
        reason it survives. The portal gate takes a shared code, not an email, so most
        visitors are anonymous while they read. This rides along the moment they identify
        on a form, and the "Ready to price it up?" block sends them to exactly that form.

     To ship the second half, canvas-capture needs one line adding portal_docs to its
     submission properties. Same localStorage record, same key. */
  var VISITOR_KEY = 'canvas_visitor';
  function recordOpen(it, how) {
    try {
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push(['track', 'Opened Portal Document', {
        document: it.display,
        category: it.cat,
        tier: state.tier,
        audience: state.audience || 'full library',
        action: how
      }]);
    } catch (e) { /* never let analytics block a download */ }
    try {
      var v = JSON.parse(localStorage.getItem(VISITOR_KEY) || 'null') || {};
      v.portal_docs = (v.portal_docs || []).concat([{
        key: it.key, title: it.display, cat: it.cat, how: how, at: new Date().toISOString()
      }]).slice(-60);
      if (state.audience) v.portal_audience = state.audience;
      localStorage.setItem(VISITOR_KEY, JSON.stringify(v));
    } catch (e) { /* private mode or full quota */ }
  }

  /* force a real download even though files are on a cross-origin CDN */
  function downloadFile(url, display) {
    var ext = (url.split('?')[0].split('.').pop() || 'pdf').toLowerCase();
    var name = display.replace(/[\\/:*?"<>|]+/g, ' ').trim() + '.' + ext;
    fetch(url).then(function (r) { return r.blob(); }).then(function (b) {
      var u = URL.createObjectURL(b), a = document.createElement('a');
      a.href = u; a.download = name; document.body.appendChild(a); a.click(); a.remove();
      setTimeout(function () { URL.revokeObjectURL(u); }, 5000);
    }).catch(function () { window.open(url, '_blank'); });
  }

  /* ---------- SECTION BUILDER ---------- */
  function docSection(id, label, desc, items, isWholesale, topGated) {
    var s = el('section', 'cpp-sec'); s.id = 'sec-' + id;
    var head = el('div', 'cpp-sec__head');
    head.appendChild(el('h2', 'cpp-sec__t', esc(label)));
    if (desc) head.appendChild(el('span', 'cpp-sec__d', esc(desc)));
    if (isWholesale) head.appendChild(el('span', 'cpp-sec__lock', ICONS.lock + ' Partners only'));
    s.appendChild(head);
    var grid = el('div', 'cpp-grid');
    if (isWholesale && state.tier < 2) {
      grid.appendChild(topGated ? lockPointer() : lockPanel());
    }
    else items.forEach(function (it) { grid.appendChild(it.type === 'quote' ? quoteCard(it) : fileCard(it)); });
    s.appendChild(grid); return s;
  }

  /* ---------- VIEWS ---------- */
  function render() {
    var hero = $('.cpp-hero'), lib = $('.cpp-lib');
    lib.innerHTML = '';
    if (!state.audience) { var st = document.querySelector('.cpp-sticky'); if (st) st.remove(); }
    if (state.q) { hero.hidden = true; renderSearch(lib); return; }
    if (state.audience) { hero.hidden = true; renderDash(lib); return; }
    if (state.view === 'all') { hero.hidden = true; renderAll(lib); return; }
    hero.hidden = false; renderHome(lib);
  }

  function dashHeader(titleText, introText) {
    var head = el('div', 'cpp-dash__head');
    var back = el('button', 'cpp-back'); back.innerHTML = '&larr; All partner types';
    back.addEventListener('click', goHome);
    head.appendChild(back);
    head.appendChild(el('h1', 'cpp-dash__title', esc(titleText)));
    if (introText) head.appendChild(el('p', 'cpp-dash__intro', esc(introText)));
    return head;
  }

  /* Every package used to end in a wall of images with no way to act on any of it.
     NEXT_ASK is what we want that visitor to do, in their own terms. */
  var NEXT_ASK = {
    distributors: 'Tell us the range and the volumes you want to carry and we will come back with dealer pricing and lead times.',
    corporate: 'Send us the products, the quantities and your deadline and we will come back with pricing, a timeline and a proof.',
    weddings: 'Tell us your date, the guest count and what you have in mind and we will come back with pricing and a timeline.',
    events: 'Tell us the event date, the numbers and what you need on site and we will come back with pricing and a timeline.',
    realestate: 'Tell us the volumes and how you want them branded and we will come back with pricing and a timeline.',
    clubs: 'Tell us what your members would buy and we will come back with pricing, a timeline and artwork for your displays.'
  };
  function nextSteps(audId) {
    var n = el('section', 'cpp-next');
    n.appendChild(el('h2', 'cpp-next__t', 'Ready to price it up?'));
    n.appendChild(el('p', 'cpp-next__d', esc(NEXT_ASK[audId] ||
      'Tell us the products, the volumes and your deadline and we will come back with pricing and a timeline.')));
    var acts = el('div', 'cpp-next__acts');
    var q = el('a', 'cpp-next__b cpp-next__b--p', 'Request a quote'); q.href = CFG.contact;
    var d = el('a', 'cpp-next__b cpp-next__b--g', 'Design a paddle online'); d.href = CFG.designer;
    acts.appendChild(q); acts.appendChild(d);
    acts.appendChild(el('span', 'cpp-next__mail',
      'or email <a href="mailto:' + esc(CFG.email) + '">' + esc(CFG.email) + '</a>'));
    n.appendChild(acts); return n;
  }

  function renderHome(lib) {
    // the "See the full library" button lives in the hero (above the tiles),
    // so the home view intentionally leaves the library area empty.
  }

  /* ---------- EIGHT-BLOCK AUDIENCE PAGES ----------
     One renderer, one payload per audience (DATA.pages, generated by
     .tools/build_portal_data.py from "Portal pages (content)" 01-08). The answers
     live on the page; the PDFs render underneath as the appendix. */
  function blockHead(eyebrow, title, sub) {
    var h = el('div', 'cpp-bhead');
    h.appendChild(el('p', 'cpp-bhead__eb', esc(eyebrow)));
    h.appendChild(el('h2', 'cpp-bhead__t', esc(title)));
    if (sub) h.appendChild(el('p', 'cpp-bhead__d', esc(sub)));
    return h;
  }
  function scrollbarFor(row) {
    var bar = el('div', 'cpp-sb'), thumb = el('span', 'cpp-sb__t');
    bar.appendChild(thumb);
    function upd() {
      var max = row.scrollWidth - row.clientWidth;
      if (max < 8) { bar.style.display = 'none'; return; }
      bar.style.display = '';
      var w = Math.max(row.clientWidth / row.scrollWidth * 100, 14);
      thumb.style.width = w + '%';
      thumb.style.marginLeft = ((row.scrollLeft / max) * (100 - w)) + '%';
    }
    row.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    setTimeout(upd, 60);
    return bar;
  }
  function tableEl(cols, rows) {
    /* 4+ column tables restack into labeled row-cards on phones (cpp-tbl--wide);
       a clipped-by-a-sliver table reads as broken and is never acceptable */
    var wrap = el('div', 'cpp-tbl' + (cols.length > 3 ? ' cpp-tbl--wide' : ''));
    var t = el('table'), tr = el('tr');
    cols.forEach(function (c) { tr.appendChild(el('th', null, esc(c))); });
    var thead = el('thead'); thead.appendChild(tr); t.appendChild(thead);
    var tb = el('tbody');
    rows.forEach(function (r) {
      var row = el('tr');
      r.forEach(function (c, i) {
        var cell = el(i === 0 ? 'th' : 'td', null, esc(c));
        if (i > 0) cell.setAttribute('data-l', cols[i]);
        row.appendChild(cell);
      });
      tb.appendChild(row);
    });
    t.appendChild(tb); wrap.appendChild(t); return wrap;
  }
  function pageHero(a, pg) {
    var h = el('section', 'cpp-phero');
    var back = el('button', 'cpp-back cpp-back--hero'); back.innerHTML = '&larr; All partner types';
    back.addEventListener('click', goHome);
    h.appendChild(back);
    h.appendChild(el('p', 'cpp-phero__eb', esc(pg.hero.eyebrow || a.label)));
    h.appendChild(el('h1', 'cpp-phero__t', esc(pg.hero.title)));
    h.appendChild(el('p', 'cpp-phero__d', esc(pg.hero.intro)));
    if (pg.hero.standing) {
      var st = el('div', 'cpp-phero__standing');
      st.innerHTML = ICONS.check + '<span>' + esc(pg.hero.standing) + '</span>';
      h.appendChild(st);
    }
    return h;
  }
  function makeBlock(pg) {
    var s = el('section', 'cpp-blk');
    s.appendChild(blockHead('The products', pg.make.head));
    if (pg.make.cards && pg.make.cards.length) {
      var row = el('div', 'cpp-mk');
      pg.make.cards.forEach(function (c) {
        var card = el('article', 'cpp-mk__c');
        if (c.img) {
          var th = el('div', 'cpp-mk__img'), im = el('img');
          im.src = c.img; im.alt = c.t; im.loading = 'lazy'; th.appendChild(im); card.appendChild(th);
        }
        var b = el('div', 'cpp-mk__b');
        b.appendChild(el('h3', 'cpp-mk__t', esc(c.t)));
        b.appendChild(el('p', 'cpp-mk__d', esc(c.d)));
        b.appendChild(el('div', 'cpp-mk__p', esc(c.price)));
        card.appendChild(b); row.appendChild(card);
      });
      s.appendChild(row); s.appendChild(scrollbarFor(row));
    } else if (pg.make.trows) {
      s.appendChild(tableEl(pg.make.cols, pg.make.trows));
    }
    if (pg.make.note) s.appendChild(el('p', 'cpp-blk__note', esc(pg.make.note)));
    return s;
  }
  function costBlock(pg) {
    var s = el('section', 'cpp-blk cpp-blk--band');
    s.appendChild(blockHead('What it costs', pg.cost.head, pg.cost.body));
    if (pg.cost.locked && state.tier < 2) {
      var lp = el('div', 'cpp-lockptr');
      lp.innerHTML = ICONS.lock + '<span>Trade pricing is locked. Enter your wholesale code in the <b>Wholesale &amp; partner pricing</b> box further down this page to open the rates.</span>';
      s.appendChild(lp);
    }
    if (pg.cost.cols && pg.cost.rows) s.appendChild(tableEl(pg.cost.cols, pg.cost.rows));
    if (pg.cost.notes && pg.cost.notes.length) {
      var ul = el('ul', 'cpp-notes');
      pg.cost.notes.forEach(function (n) { ul.appendChild(el('li', null, esc(n))); });
      s.appendChild(ul);
    }
    return s;
  }
  function timingBlock(pg) {
    var s = el('section', 'cpp-blk');
    s.appendChild(blockHead('Timing', pg.timing.head));
    var ol = el('ol', 'cpp-tl');
    pg.timing.steps.forEach(function (st) {
      var li = el('li', 'cpp-tl__s');
      li.appendChild(el('h3', 'cpp-tl__t', esc(st.t)));
      li.appendChild(el('p', 'cpp-tl__d', esc(st.d)));
      ol.appendChild(li);
    });
    s.appendChild(ol);
    if (pg.timing.note) s.appendChild(el('p', 'cpp-blk__note', esc(pg.timing.note)));
    return s;
  }
  function needBlock(pg) {
    var s = el('section', 'cpp-blk');
    var p = el('div', 'cpp-chk');
    p.appendChild(el('p', 'cpp-chk__eb', 'What we need from you'));
    p.appendChild(el('h2', 'cpp-chk__t', esc(pg.need.head)));
    var ul = el('ul', 'cpp-chk__l');
    pg.need.items.forEach(function (it) {
      var li = el('li');
      li.innerHTML = ICONS.check + '<span>' + esc(it) + '</span>';
      ul.appendChild(li);
    });
    p.appendChild(ul); s.appendChild(p); return s;
  }
  /* Proof is a sideways carousel of verified buyers: quote cards (verbatim from the
     testimonials ledger) and delivered-order stat cards, so a page can carry many
     without stacking. */
  function proofBlock(pg) {
    var s = el('section', 'cpp-blk');
    s.appendChild(blockHead('Proof', pg.proof.head));
    var row = el('div', 'cpp-pf');
    (pg.proof.cards || []).forEach(function (c) {
      var card = el('article', 'cpp-pf__c');
      if (c.q) {
        card.appendChild(el('p', 'cpp-pf__q', '“' + esc(c.q) + '”'));
        var ft = el('footer', 'cpp-pf__f');
        ft.appendChild(el('strong', 'cpp-pf__credit', esc(c.credit)));
        if (c.sub) ft.appendChild(el('span', 'cpp-pf__sub', esc(c.sub)));
        card.appendChild(ft);
      } else {
        if (c.stat) card.appendChild(el('div', 'cpp-pf__stat', esc(c.stat)));
        card.appendChild(el('h3', 'cpp-pf__t', esc(c.t)));
        if (c.d) card.appendChild(el('p', 'cpp-pf__d', esc(c.d)));
      }
      row.appendChild(card);
    });
    s.appendChild(row);
    s.appendChild(scrollbarFor(row));
    return s;
  }
  function extraBlock(pg) {
    var s = el('section', 'cpp-blk');
    var p = el('div', 'cpp-extra');
    p.appendChild(el('h2', 'cpp-extra__t', esc(pg.extra.head)));
    if (pg.extra.items && pg.extra.items.length) {
      var ul = el('ul', 'cpp-extra__l');
      pg.extra.items.forEach(function (it) { ul.appendChild(el('li', null, esc(it))); });
      p.appendChild(ul);
    }
    if (pg.extra.body) p.appendChild(el('p', 'cpp-extra__d', esc(pg.extra.body)));
    s.appendChild(p); return s;
  }
  function docsBlock(a) {
    var s = el('section', 'cpp-blk'); s.id = 'sec-docs';
    s.appendChild(blockHead('The documents', 'The details, as PDFs',
      'Everything above is on this page. These carry the fine print, for forwarding.'));
    var open = DATA.items.filter(function (it) {
      return a.keys.indexOf(it.key) >= 0 && it.tier !== 2 &&
        (it.type === 'pdf' || it.type === 'quote');
    });
    var grid = el('div', 'cpp-grid');
    open.forEach(function (it) { grid.appendChild(it.type === 'quote' ? quoteCard(it) : fileCard(it)); });
    s.appendChild(grid);
    /* whCount comes from the build: tier 2 items are not in the public blob at all,
       so pre-unlock the count is the only sign this audience has a gated layer */
    if (a.whCount) {
      var wh = DATA.items.filter(function (it) {
        return a.keys.indexOf(it.key) >= 0 && it.tier === 2;
      });
      s.appendChild(docSection('pricing_wholesale', 'Wholesale & partner pricing', '', wh, true));
    }
    return s;
  }
  function ctaBlock(pg) {
    var n = el('section', 'cpp-cta'); n.id = 'sec-cta';
    n.appendChild(el('h2', 'cpp-cta__t', esc(pg.cta.head)));
    n.appendChild(el('p', 'cpp-cta__d', esc(pg.cta.body)));
    var acts = el('div', 'cpp-next__acts');
    var p = el('a', 'cpp-next__b cpp-next__b--p', esc(pg.cta.primary.label)); p.href = pg.cta.primary.href;
    acts.appendChild(p);
    if (pg.cta.secondary) {
      var g = el('a', 'cpp-next__b cpp-next__b--g', esc(pg.cta.secondary.label)); g.href = pg.cta.secondary.href;
      acts.appendChild(g);
    }
    acts.appendChild(el('span', 'cpp-next__mail',
      'or email <a href="mailto:' + esc(CFG.email) + '">' + esc(CFG.email) + '</a>'));
    n.appendChild(acts); return n;
  }
  function stickyCta(pg) {
    var old = document.querySelector('.cpp-sticky'); if (old) old.remove();
    var bar = el('div', 'cpp-sticky');
    var a = el('a', 'cpp-next__b cpp-next__b--p', esc(pg.cta.primary.label)); a.href = pg.cta.primary.href;
    bar.appendChild(a); root.appendChild(bar);
    if ('IntersectionObserver' in window) {
      var hero = $('.cpp-phero'), cta = $('.cpp-cta'), pastHero = false, onCta = false;
      function upd2() { bar.classList.toggle('is-on', pastHero && !onCta); }
      if (hero) new IntersectionObserver(function (e) { pastHero = !e[0].isIntersecting; upd2(); }).observe(hero);
      if (cta) new IntersectionObserver(function (e) { onCta = e[0].isIntersecting; upd2(); }).observe(cta);
    }
  }
  function renderPage(lib, a, pg) {
    lib.appendChild(pageHero(a, pg));
    lib.appendChild(makeBlock(pg));
    lib.appendChild(costBlock(pg));
    lib.appendChild(timingBlock(pg));
    lib.appendChild(needBlock(pg));
    lib.appendChild(proofBlock(pg));
    if (pg.extra) lib.appendChild(extraBlock(pg));
    lib.appendChild(docsBlock(a));
    var gimgs = catItems('image'), gcats = [];
    gimgs.forEach(function (it) { if (gcats.indexOf(it.tab) < 0) gcats.push(it.tab); });
    if (gcats.length) {
      if (!state.tab || gcats.indexOf(state.tab) < 0) state.tab = gcats[0];
      var isec = imageSection({ label: 'The pictures', cats: gcats, tab: state.tab, sub: state.sub, showTabBar: true, showSubBar: true, showExtras: false });
      if (isec) lib.appendChild(isec);
    }
    lib.appendChild(ctaBlock(pg));
    stickyCta(pg);
  }

  function renderDash(lib) {
    var a = audienceById(state.audience);
    if (!a) { state.audience = null; return renderHome(lib); }
    var pg = (DATA.pages || {})[a.id];
    if (pg) return renderPage(lib, a, pg);
    lib.appendChild(dashHeader('Your ' + a.label + ' package', AUD_INTRO[a.id] || ''));
    var path = pathStrip(a.id); if (path) lib.appendChild(path);
    DATA.sections.forEach(function (sec) {
      if (sec.id === 'image') return;
      var items = catItems(sec.id, a.keys);
      if (!items.length) return;
      lib.appendChild(docSection(sec.id, labelFor(a.id, sec.id, sec.label), '', items, sec.tier === 2));
    });
    // full image gallery at the bottom — defaults to this client's category, but all tabs/chips are browsable
    var gimgs = catItems('image'), gcats = [];
    gimgs.forEach(function (it) { if (gcats.indexOf(it.tab) < 0) gcats.push(it.tab); });
    if (gcats.length) {
      if (!state.tab || gcats.indexOf(state.tab) < 0) state.tab = gcats[0];
      var isec = imageSection({ label: 'Brand image library', cats: gcats, tab: state.tab, sub: state.sub, showTabBar: true, showSubBar: true, showExtras: false });
      if (isec) lib.appendChild(isec);
    }
    lib.appendChild(nextSteps(a.id));
  }

  function renderAll(lib) {
    // Wholesale gate first: an independent partner should immediately see how to
    // unlock pricing, before scrolling the rest of the library.
    var hasWholesale = DATA.sections.some(function (sc) { return sc.tier === 2; });
    if (hasWholesale) {
      lib.appendChild(state.tier >= 2 ? wholesaleUnlockedBar() : wholesaleGate());
    }
    lib.appendChild(dashHeader('The full library', 'Sales sheets, customer pricing, print-ready displays and the full image library. Use the tabs up top or search to jump around.'));
    DATA.sections.forEach(function (sec) {
      if (sec.id === 'image') {
        var imgs = catItems('image'), cats = [];
        imgs.forEach(function (it) { if (cats.indexOf(it.tab) < 0) cats.push(it.tab); });
        if (!state.tab || cats.indexOf(state.tab) < 0) { state.tab = cats[0]; state.sub = null; }
        var isec = imageSection({ label: sec.label, cats: cats, tab: state.tab, sub: state.sub, showTabBar: true, showSubBar: true, showExtras: true });
        if (isec) lib.appendChild(isec);
        return;
      }
      var items = catItems(sec.id);
      var isWholesale = sec.tier === 2;
      if (!items.length && !isWholesale) return;
      // topGated: the wholesale gate at the top of the page carries the unlock
      // form, so the inline wholesale section shows a short pointer (not a 2nd form)
      lib.appendChild(docSection(sec.id, sec.label, sec.desc, items, isWholesale, true));
    });
    lib.appendChild(nextSteps(null));
  }

  function wholesaleGate() {
    var p = el('div', 'cpp-gatebar');
    p.innerHTML = ICONS.lock +
      '<h2 class="cpp-gatebar__t">Wholesale &amp; partner pricing</h2>' +
      '<p class="cpp-gatebar__d">Distributor and reseller pricing, partner tier and rate sheets, and the intake form. Enter your partner code to unlock it. Do not have one yet? Ask your Canvas contact.</p>';
    var f = el('form', 'cpp-gatebar__form');
    f.innerHTML = '<input type="text" placeholder="Partner code" aria-label="Partner code" autocomplete="off"><button type="submit" class="cpp-btn">Unlock pricing</button>';
    var errd = el('div', 'cpp-gatebar__err');
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      errd.textContent = 'Checking…';
      unlockWholesale(f.querySelector('input').value).then(function (ok) {
        if (ok) { saveTier(2); setTierBadge(); render(); scrollTo('#sec-pricing_wholesale'); }
        else errd.textContent = 'That partner code did not match.';
      });
    });
    p.appendChild(f); p.appendChild(errd); return p;
  }

  function wholesaleUnlockedBar() {
    var p = el('div', 'cpp-gatebar cpp-gatebar--open');
    p.innerHTML = (ICONS.check || ICONS.lock) +
      '<h2 class="cpp-gatebar__t">Wholesale pricing unlocked</h2>' +
      '<p class="cpp-gatebar__d">Your partner pricing is open in the Wholesale &amp; Partner Pricing section below.</p>';
    var b = el('button', 'cpp-btn cpp-btn--ghost', 'Jump to wholesale pricing');
    b.addEventListener('click', function () { scrollTo('#sec-pricing_wholesale'); });
    p.appendChild(b); return p;
  }

  function renderSearch(lib) {
    lib.appendChild(dashHeader('Search', 'Results for “' + state.q + '”.'));
    var hits = DATA.items.filter(function (it) {
      if (it.type === 'image') return false;
      if (it.cat === 'pricing_wholesale' && state.tier < 2) return false;
      return (it.display + ' ' + (it.desc || '')).toLowerCase().indexOf(state.q) >= 0;
    });
    var grid = el('div', 'cpp-grid');
    if (!hits.length) {
      grid.appendChild(el('div', 'cpp-empty',
        'Nothing here matches that. If it is something you need, ask us below and we will send it.'));
    } else {
      hits.forEach(function (it) { grid.appendChild(it.type === 'quote' ? quoteCard(it) : fileCard(it)); });
    }
    lib.appendChild(grid);
    /* Search used to be the one view with no way out, and the empty result was the worst
       of them: someone who looked for a thing we do not have got "try another word". */
    lib.appendChild(nextSteps(state.audience));
    noteSearch(state.q, hits.length);
  }

  /* A search that finds nothing is the single best signal of a content gap: it is a
     partner telling us what they expected to be here. Debounced because the results
     re-render on every keystroke, so recording raw would log every prefix. */
  var searchTimer = null;
  function noteSearch(q, hitCount) {
    if (!q || q.length < 3 || hitCount > 0) return;
    if (searchTimer) clearTimeout(searchTimer);
    searchTimer = setTimeout(function () {
      if (state.q !== q) return;              /* they kept typing; that prefix was not the query */
      try {
        var v = JSON.parse(localStorage.getItem(VISITOR_KEY) || 'null') || {};
        var misses = v.portal_searches_missed || [];
        if (misses[misses.length - 1] !== q) misses.push(q);
        v.portal_searches_missed = misses.slice(-30);
        localStorage.setItem(VISITOR_KEY, JSON.stringify(v));
      } catch (e) {}
    }, 1200);
  }

  function goHome() {
    state.audience = null; state.view = null; state.q = '';
    var si = $('.cpp-search input'); if (si) si.value = '';
    writeRoute(); render(); if (window.scrollTo) window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function fileCard(it) {
    var c = el('article', 'cpp-card');
    var thumb = el('div', 'cpp-card__thumb');
    if (it.thumb) { var im = el('img'); im.src = it.thumb; im.alt = it.display; im.loading = 'lazy'; thumb.appendChild(im); }
    else thumb.appendChild(el('div', 'cpp-card__fallback', esc(it.display)));
    if (it.badge) thumb.appendChild(el('span', 'cpp-badge cpp-badge--' + it.badge, it.badge === 'print' ? 'Print-ready' : it.badge));
    c.appendChild(thumb);
    var body = el('div', 'cpp-card__body');
    body.appendChild(el('h3', 'cpp-card__t', esc(it.display)));
    if (it.desc) body.appendChild(el('p', 'cpp-card__d', esc(it.desc)));
    if (it.meta) body.appendChild(el('div', 'cpp-card__meta', esc(it.meta)));
    var acts = el('div', 'cpp-card__acts');
    var prev = el('a', 'cpp-card__btn cpp-card__btn--v', 'Preview');
    prev.href = it.url; prev.target = '_blank'; prev.rel = 'noopener';
    prev.addEventListener('click', function () { recordOpen(it, 'preview'); });
    var dl = el('a', 'cpp-card__btn cpp-card__btn--d', 'Download');
    dl.href = it.url;
    dl.addEventListener('click', function (e) {
      e.preventDefault(); recordOpen(it, 'download'); downloadFile(it.url, it.display);
    });
    acts.appendChild(prev); acts.appendChild(dl);
    body.appendChild(acts); c.appendChild(body); return c;
  }

  function quoteCard(it) {
    var q = el('div', 'cpp-quote');
    q.innerHTML = '<p><b>' + esc(it.display) + '</b>: ' + esc(it.desc) + '</p>';
    var a = el('a', 'cpp-card__btn cpp-card__btn--d', 'Request a quote'); a.href = CFG.contact; a.style.flex = '0 0 auto'; a.style.padding = '.6rem 1.2rem';
    q.appendChild(a); return q;
  }

  function lockPointer() {
    var p = el('div', 'cpp-lockptr');
    p.innerHTML = ICONS.lock + '<span>Locked. Enter your partner code in the <b>Wholesale &amp; partner pricing</b> box at the top of the page to unlock these.</span>';
    return p;
  }

  function lockPanel() {
    var p = el('div', 'cpp-lock');
    p.innerHTML = ICONS.lock +
      '<h3 class="cpp-lock__t">Wholesale &amp; partner pricing</h3>' +
      '<p class="cpp-lock__d">Distributor and reseller pricing, partner tier and rate sheets, and the intake form. Enter your wholesale code to unlock, or ask your Canvas contact for one.</p>';
    var f = el('form', 'cpp-lock__form');
    f.innerHTML = '<input type="text" placeholder="Wholesale code" aria-label="Wholesale code" autocomplete="off"><button type="submit" class="cpp-btn">Unlock</button>';
    var errd = el('div', 'cpp-lock__err');
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      errd.textContent = 'Checking…';
      unlockWholesale(f.querySelector('input').value).then(function (ok) {
        if (ok) { saveTier(2); setTierBadge(); render(); scrollTo('#sec-pricing_wholesale'); }
        else errd.textContent = 'That wholesale code didn’t match.';
      });
    });
    p.appendChild(f); p.appendChild(errd); return p;
  }

  /* ---------- IMAGE GALLERY (category tabs + sub-category chips) ---------- */
  function imageSection(opts) {
    var imgs = catItems('image');
    if (!imgs.length) return null;
    var inCat = imgs.filter(function (it) { return it.tab === opts.tab; });
    if (!inCat.length) return null;
    var s = el('section', 'cpp-sec'); s.id = 'sec-image';
    var head = el('div', 'cpp-sec__head');
    head.appendChild(el('h2', 'cpp-sec__t', esc(opts.label || 'Brand images')));
    s.appendChild(head);
    if (opts.showExtras) {
      var vids = catItems('video');
      if (vids.length || CFG.biglib) {
        var g0 = el('div', 'cpp-grid'); g0.style.marginBottom = '1.4rem';
        vids.forEach(function (v) { g0.appendChild(fileCard(v)); });
        if (CFG.biglib) {
          var big = el('div', 'cpp-quote');
          big.innerHTML = '<p><b>Full social &amp; photo archive</b>: the complete high-res library (1GB+), by category.</p>';
          var a = el('a', 'cpp-card__btn cpp-card__btn--d', 'Open library'); a.href = CFG.biglib; a.target = '_blank'; a.rel = 'noopener';
          a.style.flex = '0 0 auto'; a.style.padding = '.6rem 1.2rem'; big.appendChild(a); g0.appendChild(big);
        }
        s.appendChild(g0);
      }
    }
    if (opts.showTabBar && opts.cats) {
      var tabRow = el('div', 'cpp-tabs');
      opts.cats.forEach(function (t) {
        var b = el('button', 'cpp-tab' + (t === opts.tab ? ' is-on' : ''), esc(t));
        b.addEventListener('click', function () { state.tab = t; state.sub = null; render(); scrollTo('#sec-image'); });
        tabRow.appendChild(b);
      });
      s.appendChild(tabRow);
    }
    var gallery = inCat;
    if (opts.showSubBar) {
      var subs = [];
      inCat.forEach(function (it) { if (it.subtab && subs.indexOf(it.subtab) < 0) subs.push(it.subtab); });
      if (subs.length) {
        var subRow = el('div', 'cpp-subs');
        var allc = el('button', 'cpp-sub' + (!opts.sub ? ' is-on' : ''), 'All');
        allc.addEventListener('click', function () { state.sub = null; render(); scrollTo('#sec-image'); });
        subRow.appendChild(allc);
        subs.forEach(function (sub) {
          var b = el('button', 'cpp-sub' + (sub === opts.sub ? ' is-on' : ''), esc(sub));
          b.addEventListener('click', function () { state.sub = sub; render(); scrollTo('#sec-image'); });
          subRow.appendChild(b);
        });
        s.appendChild(subRow);
      }
    }
    if (opts.sub) gallery = inCat.filter(function (it) { return it.subtab === opts.sub; });
    var gal = el('div', 'cpp-gal');
    gallery.forEach(function (it) {
      var d = el('div', 'cpp-gal__i'); var im = el('img'); im.src = it.url; im.alt = it.display; im.loading = 'lazy';
      d.appendChild(im); d.addEventListener('click', function () { openLB(it.url); }); gal.appendChild(d);
    });
    s.appendChild(gal); return s;
  }

  /* ---------- LIGHTBOX ---------- */
  function openLB(url) {
    var lb = $('.cpp-lb'); $('.cpp-lb img').src = url; $('.cpp-lb__dl').href = url; lb.classList.add('is-on');
  }

  /* ---------- NAV / SCROLL ---------- */
  function scrollTo(sel) { var e = $(sel); if (e) e.scrollIntoView({ behavior: 'smooth', block: 'start' }); }

  function wire() {
    root.addEventListener('click', function (e) {
      if (e.target.closest('.cpp-brand')) { e.preventDefault(); goHome(); return; }
      if (e.target.closest('[data-open-all]')) {
        state.view = 'all'; state.audience = null; state.q = '';
        $('.cpp-search input').value = ''; writeRoute(); render();
        if (window.scrollTo) window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      var t = e.target.closest('[data-aud]');
      if (t) {
        selectAudience(t.getAttribute('data-aud'));
        render();
        if (window.scrollTo) window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      var nav = e.target.closest('[data-jump]');
      if (nav) {
        e.preventDefault(); state.view = 'all'; state.audience = null; state.q = '';
        $('.cpp-search input').value = ''; render();
        scrollTo('#sec-' + nav.getAttribute('data-jump'));
        return;
      }
    });
    $('.cpp-search input').addEventListener('input', function (e) {
      state.q = e.target.value.trim().toLowerCase(); render();
    });
    $('.cpp-head__exit').addEventListener('click', function () { location.reload(); });
    $('.cpp-lb__x').addEventListener('click', function () { $('.cpp-lb').classList.remove('is-on'); });
    $('.cpp-lb').addEventListener('click', function (e) { if (e.target === this) this.classList.remove('is-on'); });
    // inject audience icons
    root.querySelectorAll('[data-icon]').forEach(function (n) { n.innerHTML = ICONS[n.getAttribute('data-icon')] || ''; });
    // a hash edited after unlock still routes
    window.addEventListener('hashchange', function () {
      if (state.tier < 1) return;
      var r = readRoute();
      if (r && r.audience) { selectAudience(r.audience); render(); }
      else if (r && r.view) { state.view = 'all'; state.audience = null; render(); }
    });
  }

  /* The sorter tiles come from the data blob (one source for audiences), not from
     hand-maintained markup. New audience in build_portal_data.py = new tile here. */
  function renderTiles() {
    var wrap = $('.cpp-tiles'); if (!wrap) return;
    wrap.innerHTML = '';
    DATA.audiences.forEach(function (a) {
      var b = el('button', 'cpp-tile'); b.setAttribute('data-aud', a.id); b.type = 'button';
      b.innerHTML = '<span class="cpp-tile__ic">' + (ICONS[a.icon] || '') + '</span>' +
        '<span class="cpp-tile__t">' + esc(a.label) + '</span>' +
        '<span class="cpp-tile__d">' + esc(a.desc || '') + '</span>' +
        '<span class="cpp-tile__go">Open your page &rarr;</span>';
      wrap.appendChild(b);
    });
  }

  renderTiles();
  wire();
  initGate();
})();
